import ApplicationRecord from './ApplicationRecord';
import _ from 'lodash';
import Contact from './Contact';

export default class OpeningHours
  extends ApplicationRecord({
    ID: 0,
    CloseHour: '',
    CloseMinute: '',
    OpenHour: '',
    OpenMinute: '',
    Description: '',
    _embedded: {},
  }) {
  /**
   * @return {String} Ex: 07h40
   */
  open() {
    const hour = _.toInteger(this.OpenHour);
    const hourStr = (hour < 10 ? '0' : '') + hour;
    const minute = _.toInteger(this.OpenMinute);
    const minuteStr = (minute < 10 ? '0' : '') + minute;
    return hourStr + 'h' + minuteStr;
  }
  /**
   * @return {String} Ex: 12h00
   */
  close() {
    const hour = _.toInteger(this.CloseHour);
    const hourStr = (hour < 10 ? '0' : '') + hour;
    const minute = _.toInteger(this.CloseMinute);
    const minuteStr = (minute < 10 ? '0' : '') + minute;
    return hourStr + 'h' + minuteStr;
  }
  /**
   * @return {Contact} Contact
   */
  contact() {
    return this._getOne('ContactPoint', Contact);
  }
}



// WEBPACK FOOTER //
// ./src/models/OpeningHours.js